module.exports = __webpack_public_path__ + "static/power-img3-2-86ee3388a45d6f2e2bdc02844ca0692e.png";